$(document).ready ->
  $('.email-list .email-status').on 'ajax:success', ->
    me = $ @
    a = me.find('a')
    me.find('.email-link-text').text(a.attr("data-after-submit"))
    me.html a.html()
    me.find('.fa').removeClass('fa-refresh fa-spin').addClass('fa-envelope-o')
